import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import Media from 'react-media';
import { colors } from '../../../styled/theme';
import { container } from '../../../styled/mixins';
import mediaQueries from '../../../utils/mediaQueries';
import { piper } from '../../../assets/illustrations/illustrationRepository';
import PricingSection from './PricingSection';

const Hero = styled.div`
  background: ${colors.secondary};
  width:100%;
  margin: 0;
  padding-top: 32px;
  padding-bottom: 54px;
  @media ${mediaQueries.lgPlusUp} {
    display: flex;
    justify-content: center;
    padding-top: 64px;
    padding-bottom: 68px;
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  @media ${mediaQueries.lgPlusUp} {
    display: grid;
    margin-right: 24px;
  }
`;
const TitleContainer = styled.div`
  max-width: 140px;
  @media ${mediaQueries.lgPlusUp} {
    max-width: 252px;
  }
`;
const Title = styled.h1`
  color: ${colors.black};
  font-size: 40px;
  font-weight: bold;
  line-height: 54px;
`;
const Subtitle = styled.p`
  font-size: 19px;
  line-height: 26px;
  margin: 0;
  margin-top: 12px;
  @media ${mediaQueries.lgPlusUp} {
    font-size: 28px;
    line-height: 38px;
  }
`;
const PiperContent = styled.div`
  align-self: end;
`;
const PiperContainer = styled.div`
  display: flex;
  position: relative;
  right: -18px;
  width: 172px;
  margin-top: 66px;
  @media ${mediaQueries.lgPlusUp} {
    width: 239px;
    margin-top: 0;
    right: 0;
    bottom: -68px;
    left: -16px;
  }
`;
const Piper = styled.img`
  width: 100%;
`;

const PricingHero = ({ title = '', className }) => {
  const intl = useIntl();
  return (
    <Media queries={mediaQueries}>
      {(matches) => (
        <Hero>
          <Container className={className}>
            <TitleContainer>
              <Title>{title}</Title>
              <Subtitle>
                <FormattedMessage
                  id="newPricing.subtitle"
                  defaultMessage="Select a plan that works for you"
                />
              </Subtitle>
            </TitleContainer>
            <PiperContent>
              <PiperContainer>
                <Piper
                  src={
                    matches.lgPlusDownLess
                      ? piper.PiperSitting
                      : piper.PiperSittingRight
                  }
                />
              </PiperContainer>
            </PiperContent>
          </Container>
          <PricingSection />
        </Hero>
      )}
    </Media>
  );
};

PricingHero.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
};

PricingHero.defaultProps = {
  className: '',
};

export default PricingHero;
